import BaseRepository from "@/services/resources/repository";
import byNewsItem from "@/services/resources/mixins/query-by-news-item";
import byKeyword from "@/services/resources/mixins/query-by-keyword";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byNewsItem).$mix(byKeyword);
    }
}

export default Repository;
